<template>
  <el-dialog class="setting" title="修改密码" :visible.sync="visible" width="500px" :before-close="onClose" :close-on-click-modal="false">
    <el-form :model="userInfo" label-width="100px" :rules="rules" ref="passwordForm" style="margin-top: 20px;">
      <el-form-item prop="oldPassword" label="原密码">
        <el-input show-password v-model="userInfo.oldPassword" placeholder="请输入原密码"></el-input>
      </el-form-item>
      <el-form-item prop="newPassword" label="新密码">
        <el-input show-password v-model="userInfo.newPassword" placeholder="请输入新密码"></el-input>
      </el-form-item>
      <el-form-item prop="repeatPassword" label="确认新密码">
        <el-input show-password v-model="userInfo.repeatPassword" placeholder="请确认新密码"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="onClose()">取 消</el-button>
      <el-button type="primary" @click="onSubmit()">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: "password",
  data() {
    const validatePassRepeat = (rule, value, callback) => {
      if (value === this.userInfo.oldPassword) {
        callback(new Error('新密码与原密码不能一样'))
      } else {
        callback()
      }
    }
    const validatePass = (rule, value, callback) => {
      if (value !== this.userInfo.newPassword) {
        callback(new Error('与新密码不一致'))
      } else {
        callback()
      }
    }
    return {
      userInfo: {
        oldPassword: '',
        newPassword: '',
        repeatPassword: ''
      },
      rules: {
        oldPassword: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入原密码'
          }
        ],
        newPassword: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入新密码'
          },
          {
            validator: validatePassRepeat,
            message: '新密码与原密码不能一样',
            trigger: 'blur'
          }
        ],
        repeatPassword: [
          {
            required: true,
            trigger: 'blur',
            message: '请确认新密码'
          },
          {
            validator: validatePass,
            message: '与新密码不一致',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    onClose() {
      this.$refs.passwordForm.clearValidate()
      this.$emit("close");
    },
    onSubmit() {
      this.$refs['passwordForm'].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.$http({
          url: "/modifyPwd",
          method: "put",
          data: this.userInfo
        }).then(() => {
          this.$emit("close");
          this.$message.success("修改成功");
          this.$wsApi.close(3000);
          sessionStorage.removeItem("accessToken");
          sessionStorage.removeItem("accessId");
          this.$router.push("/");
        })
      });
    }
  },
  props: {
    visible: {
      type: Boolean
    }
  }
}
</script>